import type { SVGProps } from 'react';
const SvgIconSafe = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M4.75 4a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5A.75.75 0 0 0 4.75 4M4 8.75a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0z"
    />
    <path fill="currentColor" fillRule="evenodd" d="M10 5.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-.5 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0" clipRule="evenodd" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 1h-9A2.5 2.5 0 0 0 1 3.5v8A2.5 2.5 0 0 0 3.5 14v.75c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25V14h3v.75c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25V14a2.5 2.5 0 0 0 2.5-2.5v-8A2.5 2.5 0 0 0 12.5 1m-10 2.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconSafe;
